<template>
  <div>
    <lecturer-list v-show="tabType === 1" @handleShow="handleShow" />
    <lecturer-show v-if="tabType === 2" @handleShow="handleShow" :rowItem="rowItem" />
  </div>
</template>

<script>
import lecturerList from './list.vue'
import lecturerShow from './show.vue'
export default {
  components: { lecturerList, lecturerShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>